import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { LojaFormComp, LojaListComp } from 'pages/cadastro/loja/components';
import { LojaStepProvider } from 'pages/cadastro/loja/contexts';

export function LojaForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['LOJA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <FormProvider>
                <LojaStepProvider>
                    <LojaFormComp />
                </LojaStepProvider>
            </FormProvider>
        </ListagemProvider>
    );
}

export function LojaList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['LOJA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <LojaListComp />
        </ListagemProvider>
    );
}
